"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineButtonWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var LineButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/LineButton"));
var CheckboxNoLabel_1 = __importDefault(require("atomicComponents/atoms/Forms/CheckboxNoLabel"));
var general_1 = require("utils/general");
exports.LineButtonWrapper = (0, material_1.styled)(LineButton_1.default, { shouldForwardProp: (0, general_1.omitProps)('checked', 'neutralByDefault') })(function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var theme = _a.theme, _k = _a.color, color = _k === void 0 ? 'neutral' : _k, checked = _a.checked, neutralByDefault = _a.neutralByDefault;
    return (__assign(__assign(__assign({}, (neutralByDefault && {
        borderColor: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.main,
        color: (_c = theme.palette.neutral) === null || _c === void 0 ? void 0 : _c.contrastText,
    })), { '.MuiButton-outlinedNeutral': { color: (_d = theme.palette.neutral) === null || _d === void 0 ? void 0 : _d.contrastText }, '.MuiCheckbox-root': {
            marginRight: theme.spacing(1),
            svg: {
                color: neutralByDefault && !checked ? (_e = theme.palette.neutral) === null || _e === void 0 ? void 0 : _e.contrastText : (_f = theme.palette[color]) === null || _f === void 0 ? void 0 : _f.main,
            },
        }, ':hover': {
            svg: { color: (_g = theme.palette[color]) === null || _g === void 0 ? void 0 : _g.main },
        }, label: {
            marginBottom: 0,
            cursor: 'inherit',
        } }), (checked && {
        '&.MuiButton-outlinedNeutral': {
            borderColor: (_h = theme.palette.neutral) === null || _h === void 0 ? void 0 : _h.contrastText,
            backgroundColor: (_j = theme.palette.neutral) === null || _j === void 0 ? void 0 : _j.light,
            color: theme.palette.riverstone,
            svg: { color: theme.palette.riverstone },
        },
        borderColor: theme.palette[color].dark,
        color: theme.palette[color].dark,
        backgroundColor: theme.palette[color].light,
        svg: { color: theme.palette[color].dark },
    })));
});
var CheckboxButton = function (_a) {
    var btnProps = _a.btnProps, noBorders = _a.noBorders, _b = _a.input, label = _b.label, onChange = _b.onChange, input = __rest(_b, ["label", "onChange"]), children = _a.children, props = __rest(_a, ["btnProps", "noBorders", "input", "children"]);
    return ((0, jsx_runtime_1.jsxs)(exports.LineButtonWrapper, __assign({ color: "neutral" }, btnProps, { checked: !!(input.value || input.checked), onClick: function () { return onChange(!(input.value || input.checked)); } }, { children: [(0, jsx_runtime_1.jsx)(CheckboxNoLabel_1.default, __assign({ size: (btnProps === null || btnProps === void 0 ? void 0 : btnProps.size) === 'large' ? 'medium' : btnProps === null || btnProps === void 0 ? void 0 : btnProps.size }, input, props, { checked: !!(input.value || input.checked), id: input.name, tabIndex: -1 })), (0, jsx_runtime_1.jsx)("label", { children: children !== null && children !== void 0 ? children : props.label })] })));
};
exports.default = CheckboxButton;
